import React, { useState } from 'react'
import { Helmet } from 'react-helmet'

import { makeStyles, useTheme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import CssBaseline from '@material-ui/core/CssBaseline'
import AppBar from '@material-ui/core/AppBar'

import NNLogo from 'images/NN-logo.png'
// import NNLogo from 'images/dual-logo.png'

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.text.body,
  },
  navBar: {
    backgroundColor: theme.palette.common.white,
    color: 'white',
    boxShadow: 'none',
    padding: '1.3rem 0 0',
  },
  title: {
    color: theme.palette.text.header,
    margin: '1rem 0',
    fontFamily: theme.typography.header,
  },
  subTitle: {
    marginBottom: '1rem',
    fontFamily: theme.typography.header,
    color: theme.palette.text.header,
  },
  summary: {
    color: theme.palette.text.header,
  },
  mail: {
    marginLeft: '5px',
  },
  moreInfoTitle: {
    fontFamily: theme.typography.header,
    color: theme.palette.text.header,
    marginTop: '2rem',
    fontSize: '1.5rem',
  },
  learnMore: {
    marginTop: '2rem',
  },
  font16: {
    fontSize: '1rem',
  },
  footer: {
    height: '2rem',
  },
  faqItem: {
    marginBottom: '1rem',
  },
  marginTop16: {
    marginTop: '1rem',
  },
}))

const policy = () => [
  {
    summary: 'The data we collect',
    details: [
      'All consumer personal information provided by themselves and submitted by this APP. ',
      'Personal GPS location data of APP users, when turning on “Running man”. ',
      'Device data may be collected when there is an unexpected crash or software error. ',
    ],
  },
  {
    summary: 'How we use personal data ',
    details: [
      'All consumer personal data will be used for offering assistance and case management, and may be shared with general practitioners , health services and other community services providers. ',
      'Personal GPS location data is used for reporting and analysis. ',
      'Device data will be accessed by developer for fixing or testing technical problems. ',
    ],
  },
  {
    summary: 'Who can access ',
    details: [
      'System administrator in IT department. ',
      'Way2Home manager or staffs who is given permission.  ',
    ],
  },
]

const Landing = () => {
  const classes = useStyles()
  const theme = useTheme()
  const [expandedIndex, setExpandedIndex] = useState(-1)
  const handleChange = panelIndex => () => {
    if (expandedIndex !== panelIndex) {
      setExpandedIndex(panelIndex)
      return
    }
    setExpandedIndex(-1)
  }

  return (
    <Container disableGutters={true} maxWidth="lg" className={classes.root}>
      <CssBaseline />
      <Helmet>
        <title>Way2Home App Privacy Notice </title>
      </Helmet>

      <AppBar className={classes.navBar} position="static">
        <img src={NNLogo} alt="Neaminational" style={{ width: '10rem' }} />
      </AppBar>
      <Container maxWidth="lg">
        <div>
          <Typography variant="h4" gutterBottom className={classes.title}>
            Way2Home App Privacy Notice
          </Typography>
        </div>

        <div className={classes.subTitle}>
          <Typography variant="h6" gutterBottom>
            <a href="https://www.neaminational.org.au/privacy/privacy-guidelines/">
              Neami’s Privacy Guidelines
            </a>
            ,{' '}
            <a href="https://www.neaminational.org.au/privacy/privacy-guidelines/">
              Website Privacy Statement
            </a>
            , and{' '}
            <a href="https://neaminational.org.au/privacy/app-privacy-statement/">
              App Privacy Statement
            </a>{' '}
            comply with the legal obligations of the Commonwealth Privacy Act
            1988 and the Australian Privacy Principles. Please refer to them for
            further information. Our privacy information also adheres to the
            privacy requirements of both Google Play and Apple when installing
            Neami apps from their respective stores. <br />
            <br />
          </Typography>
        </div>

        <div>
          <Typography variant="h5" gutterBottom>
            Way2Home
          </Typography>
        </div>

        <div className={classes.font16}>
          <Typography variant="subtitle1" gutterBottom>
            Way2home is an assertive outreach specialist homelessness service
            offering housing support and case management to rough sleepers aged
            25 years and above in the City of Sydney LGA.
          </Typography>
        </div>

        <div className={classes.marginTop16}>
          <Typography variant="h5" gutterBottom>
            Way2Home App
          </Typography>
        </div>

        <div className={classes.font16}>
          <Typography variant="subtitle1" gutterBottom>
            To enable the Way2Home Programme (specifically assertive outreach
            patrols to engage with rough sleepers) to be carried out in a more
            streamlined and efficient manner, and to enable data analysis to be
            carried out, Neami created a mobile application (app) for staff to
            use.
          </Typography>
        </div>

        <div className={classes.font16}>
          <Typography variant="subtitle1" gutterBottom>
            The Way2Home App (App) is available on both the Google Play App
            Store and the Apple App Store.
          </Typography>
        </div>

        <div className={classes.marginTop16}>
          <Typography variant="h5" gutterBottom>
            Types of information collected
          </Typography>
        </div>

        <div className={classes.font16}>
          <Typography variant="subtitle1" gutterBottom>
            Once an individual has agreed to be part of the Way2Home programme,
            a staff member will use the Way2Home App to complete a registration
            form. The registration form on the Way2Home App collects personal
            information about a consumer, including:
          </Typography>
        </div>

        {[
          'Name',
          'Date of birth',
          'Gender',
          'Contact details',
          'Details of the consumer’s belongings',
          'Acceptance of the consent form to engage in the Way2Home programme',
          'Housing history',
          'Source of income',
          'Names of other service providers involved in assisting the consumer',
          'Information regarding the consumer’s physical and mental wellbeing',
          'Location of the consumer (see section below)',
        ].map((content, index) => (
          <React.Fragment>
            <ul>
              {
                <li className={classes.faqItem} key={content}>
                  <div>
                    <Typography>{`${content};`}</Typography>
                  </div>
                </li>
              }
            </ul>
          </React.Fragment>
        ))}

        <div className={classes.font16}>
          <Typography variant="subtitle1" gutterBottom>
            The information collected on the registration form may vary
            depending on the consumer and available information. <br />
            Location data of the staff member is collected when using the App
            (see section below). <br />
            Device data may be collected where there is an unexpected crash or
            software error. <br />
          </Typography>
        </div>

        <div className={classes.marginTop16}>
          <Typography variant="h5" gutterBottom>
            Location services
          </Typography>
        </div>

        <div className={classes.font16}>
          <Typography variant="subtitle1" gutterBottom>
            The Way2Home App uses a location services function to collect
            location data of a staff member’s route (either by foot or car)
            during each shift. The location services function is activated only
            by the staff member clicking start on the "running man" icon on the
            App. The location services feature will stop once the staff member
            clicks stop on the "running man" icon. <br />
            <br />
            "Running man" is a feature in the App that allows for the location
            to start/stop tracking only whilst using the App (in the foreground
            only). This location feature also allows for staff to drop pins in
            locations where they talk to a consumer or an individual, or if the
            staff member has found unidentified belongings (such as a tent or
            bag). <br />
            <br />
            When logging into the App for the first time, the App provides a
            prompt requesting staff to consent to the location services
            function. Staff must select "Allow While Using App" in order to use
            the location function of "running man" and to be able to drop pins.
            The prompt alerts the staff member that they must click "stop" on
            "running man" in order for the location services function to stop
            tracking their location. <br />
            <br />
            Once "running man" has been manually started, the App (including
            location services) will continue to run on the App, including when
            the device is locked, until it is manually stopped. If the "running
            man" feature is not manually started/stopped, location services do
            not automatically run in the background of the device <br />
            <br />
            The Way2Home App, via the "running man" location services feature,
            also collects the location of a consumer (as part of the
            registration form described above) by way of a "dropped pin". The
            App also allows staff to drop pins of individuals anonymously.{' '}
            <br />
          </Typography>
        </div>

        <div className={classes.marginTop16}>
          <Typography variant="h5" gutterBottom>
            Use and disclosure of data collected
          </Typography>
        </div>

        <div className={classes.font16}>
          <Typography variant="subtitle1" gutterBottom>
            Consumers’ personal information and location data are collected to
            enable staff to carry out the services of the Way2Home programme,
            including welfare checks, assisting in case management, and
            monitoring consumers’ progression through the programme. <br />
            <br />
            Consumers’ personal information and location data may be shared with
            third parties (such as other homelessness services or other service
            providers) to enable Way2Home to provide the necessary services to
            consumers, where there are welfare or safety concerns, or where
            required by law. These addressed in the consent form, signed by the
            consumer, upon entry in the Way2Home programme. <br />
            <br />
            Staff location data is collected to enable staff to re-access
            locations when required, such as to do welfare checks, and for
            reporting and analysis purposes. <br />
            <br />
            "Dropped pins" (GPS pins) may be used where staff sights a rough
            sleeper (including information if there was an engagement and the
            nature of the engagement) and to mark belongings sighted by staff.
            These dropped pins are de-identified information. Dropped pins are
            used to give a sense of the need for homelessness services in a
            particular location. <br />
            <br />
            Device data may be accessed by the developer (Neami) for fixing
            errors or testing technical problems. <br />
            <br />
            De-identified information collected by the App may be shared with
            the City of Sydney and the Department of Communities and Justice
            (the funders) on matters, such as the number and type of engagement
            staff have with consumers/individuals and dropped pins. <br />
            <br />
            Identifiable information may be shared with the City of Sydney, the
            Department of Communities and Justice, and other homelessness
            services to enable better case management and outcomes for
            consumers. This is addressed in the consent provided by the consumer
            upon entry into the service. <br />
            <br />
          </Typography>
        </div>

        <div className={classes.marginTop16}>
          <Typography variant="h5" gutterBottom>
            Storage and security of data collected
          </Typography>
        </div>

        <div className={classes.font16}>
          <Typography variant="subtitle1" gutterBottom>
            Information collected through the Way2Home App is stored through
            Amazon Web Services. <br />
            <br />
            Access to data collected through the App is limited to Neami and
            Way2Home staff, as required. <br />
            <br />
          </Typography>
        </div>

        <div className={classes.marginTop16}>
          <a id="account-deletion" />
          <Typography variant="h5" gutterBottom>
            Account deletion
          </Typography>
        </div>

        <div className={classes.font16}>
          <Typography variant="subtitle1" gutterBottom>
            The Way2Home App uses SSO (Single Sign on) services function to
            register users and manage account information. The sign in function
            is activated only when users sign in with their working email and it
            only saves emails for identifying between users. Having users
            registered can improve user experience when using the Way2Home App
            and help us to sort out any potential usage issue.
            <br />
            <br />
            To comply with the latest Google Play User Data policy, the
            developer (Neami) provides{' '}
            <a href="https://www.neaminational.org.au/find-services/way2home/">
              the support
            </a>{' '}
            for users to contact for account deletion.
            <br />
            Please be aware that the request of account deletion will also
            delete not only the account information but also all data related to
            the account. It would include activity, error message and all data
            we saved with the account.
            <br />
            <br />
            If you would like to delete your account, please contact the support
            and we will manage your account accordingly.
          </Typography>
          <br />
          <br />
        </div>

        <div className={classes.marginTop16}>
          <Typography variant="h5" gutterBottom>
            Contact us
          </Typography>
        </div>

        <div className={classes.font16}>
          <Typography variant="subtitle1" gutterBottom>
            If you have any privacy concerns, please{' '}
            <a href="https://www.neaminational.org.au/find-services/way2home/">
              contact Way2Home.
            </a>{' '}
            <br />
            <br />
            For more information on protecting your privacy and your rights to
            your information, please visit{' '}
            <a href="https://www.oaic.gov.au/">
              The Office of the Australian Information Commissioner (OAIC).
            </a>{' '}
            <br />
            <br />
            <br />
            Please note: We may make changes to this Privacy Notice from time to
            time. The most current version will be posted on our website.
          </Typography>
        </div>

        <div className={classes.footer}></div>
      </Container>
    </Container>
  )
}

export default Landing
